import React from 'react';
import { MdLocationOn } from 'react-icons/md';
import { AVCard } from 'components/AVCard';
import { TicketTypePromoDropdown } from 'components/seatingChart/MultiSelect/TicketTypePromoDropdown';
import styled from 'styled-components';
import { ResetButton } from 'components/form/buttons/ResetButton';
import { setDefaultSelected } from '../../../slices/selectedMultiselectOptions';
import { useDispatch, useSelector } from 'react-redux';
import { theme } from 'theme';
import { PriceLevelsList } from 'components/seatingChart/MultiSelect/PriceLevelsList';

const SeatsCard = styled(AVCard)`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	margin: ${theme.margin.lg};
	z-index: 10;
`;

const Container = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

const OuterContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;
const HeaderContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
	margin-bottom: ${theme.margin.smmd};
`;

const IconContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const IconContainerMobile = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;
const StyledSpan = styled.span`
	text-align: center;
`;

const StyledTicketTypePromoDropdown = styled(TicketTypePromoDropdown)`
	margin-left: ${theme.margin.lg};
	position: relative;
	top: 10px;
`;

const StyledTicketTypePromoDropdownMobile = styled(TicketTypePromoDropdown)`
	position: relative;
	top: 10px;
	width: 100%;
`;
export function MultiselectToolbar() {
	const dispatch = useDispatch();
	const isMobile = useSelector((state) => state.ui.isMobile);

	return isMobile ? renderMobile() : render();

	function render() {
		return (
			<React.Fragment>
				<SeatsCard>
					<Container>
						<IconContainer>
							<MdLocationOn size={30} />
							<StyledSpan>Seats</StyledSpan>
						</IconContainer>
						<StyledTicketTypePromoDropdown />
						<ResetButton onClick={() => dispatch(setDefaultSelected)} />
					</Container>
				</SeatsCard>
				<PriceLevelsList />
			</React.Fragment>
		);
	}

	function renderMobile() {
		return (
			<React.Fragment>
				<SeatsCard>
					<OuterContainer>
						<HeaderContainer>
							<IconContainerMobile>
								<MdLocationOn size={25} />
								<StyledSpan>Seats</StyledSpan>
							</IconContainerMobile>
							<ResetButton onClick={() => dispatch(setDefaultSelected)} />
						</HeaderContainer>
						<StyledTicketTypePromoDropdownMobile />
					</OuterContainer>
				</SeatsCard>
				<PriceLevelsList />
			</React.Fragment>
		);
	}
}
